import { NodeSectionConfig } from 'ui/workflows/nodeTilePanel';
import { isDefined } from 'utils/tsHelpers';
import { NODE_TYPES } from './nodeConstants';
import { NODE_SECTION_TYPES, NODE_SECTION_TITLES, NODE_TYPES_IN_SECTION } from './sectionConstants';
import { useGetNodeConfig } from './utils';

export const NODES_SECTIONS_CONFIG = [
  NODE_SECTION_TYPES.ANNOTATIONS,
  NODE_SECTION_TYPES.MESSAGES,
  NODE_SECTION_TYPES.DELAY,
  NODE_SECTION_TYPES.FILTER_AND_FLOW,
  NODE_SECTION_TYPES.USER_UPDATES,
  NODE_SECTION_TYPES.INTEGRATIONS,
];

export const FB_WORKFLOWS_ALLOWED_NODE_TYPES = [
  NODE_TYPES.ADD_USER_TO_FB,
  NODE_TYPES.REMOVE_USER_FROM_FB,
];

export const getNodeSections = (
  excludedNodes: string[] = [],
  isFeatureFlagged?: boolean /** for getting node config with all/all search query */,
): NodeSectionConfig[] => {
  const isDefinedFeatureFlag = isDefined(isFeatureFlagged);
  const getNodeConfig = useGetNodeConfig(isDefinedFeatureFlag);

  return NODES_SECTIONS_CONFIG.map((section) => ({
    name: NODE_SECTION_TITLES[section],
    tileSection: section,
    nodes: NODE_TYPES_IN_SECTION[section]
      .filter((nodeType: string) => !excludedNodes.includes(nodeType))
      .map(getNodeConfig),
  }));
};

/**
 * List of all node types grouped by tile section
 */
export const NODES_LIST: NodeSectionConfig[] = getNodeSections();
